import { salt, apiUrl, apiUrlAuth, httpsUrl } from "./config"
import axios from './http';
import toastr from 'toastr';
import $ from 'jquery';
import { isMobile } from "mobile-device-detect";
import store from "../store";



export let cipher = (salt) => {
  let textToChars = text => text.split('').map(c => c.charCodeAt(0))
  let byteHex = n => ("0" + Number(n).toString(16)).substr(-2)
  let applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code)

  return text => text.split('')
    .map(textToChars)
    .map(applySaltToChar)
    .map(byteHex)
    .join('')
}


export function decipher(salt) {
  let textToChars = text => text.split('').map(c => c.charCodeAt(0))
  // let saltChars = textToChars(salt)
  let applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code)
  return encoded => encoded.match(/.{1,2}/g)
    .map(hex => parseInt(hex, 16))
    .map(applySaltToChar)
    .map(charCode => String.fromCharCode(charCode))
    .join('')
}




export function setLocalStorage(key, value) {
  const prefixKey = "axe__" + key;

  window.localStorage[prefixKey] = typeof value == 'object' ? JSON.stringify(value) : value;
}

export function getLocalStorage(key, defaultValue = null) {
  const prefixKey = "axe__" + key;
  const val = window.localStorage[prefixKey];
  let parsed = null;
  
  if (!val) {
    return defaultValue;
  }

  try {
    parsed = JSON.parse(val);
  } catch (e) {
    parsed = val;
  }

  return parsed;
}

export function resetLocalStorage() {
  window.localStorage.clear();
}


export function setAuthKey(key) {
  const encKey = cipher(salt)(key);
  setLocalStorage('key', encKey);

  return true;
}


export function getAuthKey() {
  const key = getLocalStorage('key');
  
  return key !== null ? decipher(salt)(key) : null;
}




export async function authRequest(router, path='/', data={}, method='get') {

  const authKey = getAuthKey();

  try {
    const request = await axios({
      method,
      url: apiUrlAuth + path,
      headers: {
        'Authorization': "Bearer " + authKey
      },
      data
    });
  
    return request.data;
  } catch (error) {

    if ( !(error.response.status == 401) ) {
      console.error('Cannot process this request', error);
      return error;
    } 

    const isLogged = await axios({
      method: 'get',
      url: apiUrl + '/is_auth',
      headers: {
        'Authorization': "Bearer " + authKey
      }
    });

    if (isLogged.data == false) {
      router.push({
        name: 'login'
      })
    } else {
      console.error('Cannot process this request', error);
    }
  }
}



/* 
 * Get application resource from api
 */
export async function getAppResource(key) {
  const res = getLocalStorage(key);

  if (res) {
    return res
  }

  const req = await axios.get(apiUrl + '/resource/' + key);
  
  if (req.data) {
    setLocalStorage(key, req.data);
    return req.data;
  }

  return null;
}



/**
 * Logout request
 */
export async function logout(router, toHttps = false) {
  const req = await authRequest(router, '/logout', {}, 'post');
  
  if (req.status == 1) {
    toastr.success(req.message);
    store.commit('user', {});
    store.commit('avatar', null);
    
    if (toHttps) {
      window.location.href = httpsUrl;
    } else {
      router.push({name: 'login'}); // move to login page
    }
  } else {
    toastr.error(req.message);
  }
}





/**
 * Log to console on development mode
 */
export function log(...params) {
  if ( !(process.env.NODE_ENV == 'development') )
    return null;

  console.log('%c' + params, 'color: blue; font-weight: bold;');
}




/**
 * Check for smaller device or for mobile device
 * @param minWidth Minimum width for desktop 
 * @return boolean
 */
export function isSmallerDevice(minWidth = 1055) {
  const windowWidth = $(window).width();
  
  if (isMobile || windowWidth < minWidth) {
    return true;
  } else {
    return false;
  }
}